module.exports = __webpack_public_path__ + "img/icon_happy_download_code.d05279b6.png";